export default "__VITE_ASSET__178390da__"